import { ResultSet } from "@cubejs-client/core";
import { AppThunk } from "appThunk";
import { DateTime } from "luxon";
import { cubeProductQueryFilterHelper } from "modules/helpers/cube/cubeSlice";
import { logError } from "modules/helpers/logger/loggerSlice";

import { Operator } from "modules/customer/tools/product/operator";
import { Store } from "modules/customer/tools/product/store";
import { Range } from "modules/customer/tools/product/storeRangeFilters/range";
import { Partner } from "modules/customer/tools/product/partner";

export const loadNumberStoresSellingRange = (
    referenceDate: DateTime,
    partner?: Partner,
    selectedRange?: Range,
    selectedStore?: Store,
    operator?: Operator
): AppThunk<Promise<number>> => async (dispatch) => {
    try {
        if (!referenceDate || !partner || !selectedRange) {
            return [];
        }

        const startDate = referenceDate.minus({ months: 12 }).startOf('month').startOf('day');
        const endDate = referenceDate.endOf('day');
        const query = {
            measures: [
                "ProductSalesEstimate.CountDistinctStoreIds"
            ],
            timeDimensions: [{
                dimension: "D_Date.Date",
                dateRange: [startDate, endDate]
            }],
            filters: [],
            segments: [
                "D_Store.OpenPhysicalStores"
            ],
            order: [["D_Date.MonthStartDate", "asc"]]
        };

        const resultSet = await dispatch(
            cubeProductQueryFilterHelper(query, operator, partner, selectedStore, selectedRange)
        ) as unknown as ResultSet;
        return resultSet.rawData()[0]["ProductSalesEstimate.CountDistinctStoreIds"];
    } catch (error) {
        dispatch(logError("Error loading NumberOfStoresSellingRange.", error));
        throw error;
    }
};
